function calculatePageNumber (i: number, currentPage: number, paginationRange: number, totalPages: number): number {
    const halfWay: number = Math.ceil(paginationRange / 2);

    if (i === paginationRange) {
        return totalPages;
    } else if (i === 1) {
        return i;
    } else if (paginationRange < totalPages) {
        if (totalPages - halfWay < currentPage) {
            return totalPages - paginationRange + i;
        } else if (halfWay < currentPage) {
            return currentPage - halfWay + i;
        } else {
            return i;
        }
    } else {
        return i;
    }
}

// adapted from https://github.com/syncthing/syncthing/blob/2656c1b8e1484caa479d1f0ba379240050f3cade/gui/default/vendor/angular/angular-dirPagination.js#L425
export function generatePagesArray (currentPage: number, totalPages: number, paginationRange: number): string[] {
    const pages: string[] = [];
    const halfWay: number = Math.ceil(paginationRange / 2);
    let position: string;
    const ELLIPSIS: string = '...';

    if (totalPages <= 0) {
        throw new Error('Total pages must be greater than 0');
    }

    if (currentPage > totalPages) {
        throw new Error('Current page must not be greater than the total pages value');
    }

    if (currentPage <= halfWay) {
        position = 'start';
    } else if (totalPages - halfWay < currentPage) {
        position = 'end';
    } else {
        position = 'middle';
    }

    const ellipsesNeeded: boolean = paginationRange < totalPages;
    let i: number = 1;

    while (i <= totalPages && i <= paginationRange) {
        const pageNumber: number = calculatePageNumber(i, currentPage, paginationRange, totalPages);
        const openingEllipsesNeeded: boolean = (i === 2 && (position === 'middle' || position === 'end'));
        const closingEllipsesNeeded: boolean = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));

        if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
            pages.push(ELLIPSIS);
        } else {
            pages.push(pageNumber.toString());
        }

        i = i + 1;
    }

    return pages;
}
